import makeStyles from '@mui/styles/makeStyles';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FFF',
    overflow: 'hidden',
    '&.block': {
      display: 'block'
    }
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    zIndex: `${theme.zIndex.appBar - 1} !important`
  },
  drawerPaper: {
    width: drawerWidth,
    zIndex: `${theme.zIndex.appBar - 1} !important`
  },
  drawerMobile: {
    width: drawerWidth + 30,
    flexShrink: 0,
    zIndex: `${theme.zIndex.appBar - 1} !important`
  },
  drawerPaperMobile: {
    width: drawerWidth + 30
  },
  drawerIcon: {
    '&:focus': {
      outline: '0 !important',
      boxShadow: 'none'
    },
    '&:hover': {
      background: 'none'
    }
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    backgroundColor: '#FFF'
  },
  appBar: {
    width: '100%',
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(6),
    paddingTop: theme.spacing(1.5),
    paddingBottom: 0,
    background: theme.palette.focus00.main,
    '&.obo': {
      paddingTop: theme.spacing(4)
    },
    '& ul.MuiGrid-container': {
      padding: 0
    },
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing(9),
      padding: theme.spacing(1),
      transition: 'transform ease-in-out 0.3s',
      '&.open': {
        transform: 'translateX(240px)'
      },
      '&.closed': {
        transform: 'translateX(0)'
      },
      '&.obo': {
        paddingTop: theme.spacing(3)
      }
    },
    [theme.breakpoints.up('lg')]: {
      width: 'calc(100% - 92px - 24px)', // subtract left offset and header gutter
      left: 92,
      '&.login': {
        width: '100%',
        left: 0
      }
    }
  },
  entityRow: {
    marginTop: theme.spacing(2)
  },
  content: {
    flexGrow: 1,
    width: '100%',
    paddingTop: theme.spacing(20),
    padding: '0px 20px 20px 20px',
    maxWidth: '140em',
    minHeight: 'calc(100vh - 17px)', // minus footer (to prevent double vertical scrollbar issues seen in expense tracker iFrame views)
    transition: 'transform ease-in-out 0.3s',
    '&.obo': {
      paddingTop: theme.spacing(22)
    },
    '&.open': {
      transform: 'translateX(240px)'
    },
    '&.closed': {
      transform: 'translateX(0)'
    },
    '&.noTransform': {
      transform: 'unset !important'
    },
    '&.isWebView': {
      paddingTop: theme.spacing(1)
    },
    [theme.breakpoints.up('lg')]: {
      paddingTop: theme.spacing(12),
      '&.obo': {
        paddingTop: theme.spacing(14)
      },
      '&.closed, &.open': {
        transform: 'translateX(0)'
      },
      '&.nav': {
        marginLeft: 92
      }
    }
  },
  logoLink: {
    '&:focus': {
      outline: '0 !important',
      boxShadow: 'none'
    }
  },
  logo: {
    display: 'block',
    height: '35px',
    width: '35px'
  },
  navigationalGrid: {
    height: '100vh'
  },
  businessEntitySelector: {
    paddingLeft: '20px',
    paddingRight: '20px',
    marginTop: '20px',
    width: '100%'
  },
  entitySelectorRoot: {
    height: 52
  },
  obo: {
    position: 'fixed',
    top: 0,
    width: '100%',
    height: 28,
    zIndex: `${theme.zIndex.appBar + 1}`,
    color: theme.palette.text.primary,
    backgroundColor: '#FFD8D8',
    [theme.breakpoints.down('lg')]: {
      transition: 'transform ease-in-out 0.3s',
      '&.open': {
        transform: 'translateX(240px)'
      },
      '&.closed': {
        transform: 'translateX(0)'
      }
    }
  },
  oboLabel: {
    lineHeight: '28px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  needHelpButton: {
    '&:focus': {
      outline: '0 !important',
      boxShadow: 'none'
    },
    padding: '8px 16px',
    textTransform: 'capitalize',
    '&:hover': {
      background: 'none'
    }
  },
  skipLink: {
    position: 'fixed',
    zIndex: 9999,
    transform: 'translateY(-100%)',
    width: '110px',
    textAlign: 'center',
    color: theme.palette.text.primary,
    background: theme.palette.background.default,
    '&:focus-visible  ': {
      transform: 'translateY(0%)'
    }
  }
}));

export default useStyles;
